var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":_vm.$t('listing.employers.title'),"icon":"mdi-account-group"}}),_c('EmployersList',{on:{"add-employer":_vm.createEmployer,"show-employer-details":_vm.employerDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }